import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { CreditCard } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { Button } from "../../../components/ui/button";
import { getRecentTransactions } from "../../../services/apiservices/support";
import Spinner from "../../../components/ui/spinner";
import moment from "moment";

const RecentTransactions = ({ dateFilter }) => {
  const [filteredCharges, setFilteredCharges] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFilteredCharges([]);
    setLoading(true);
    getRecentTransactions(10, dateFilter).then((data) => {
      setFilteredCharges(data || []);
      setLoading(false);
    });
  }, [dateFilter]);

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C] text-white border-none shadow-lg hover:shadow-xl transition-all p-24 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <CreditCard className="h-5 w-5 mr-8 text-[#9b87f5]" />
            Recent Transactions
          </CardTitle>
          <Button variant="link" className="text-[#1EAEDB]" asChild>
            <a href="/accounts" style={{ color: "#1EAEDB" }}>
              View All
            </a>
          </Button>
        </div>
        <CardDescription className="text-gray-400">
          Latest financial activities across the platform
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-md overflow-hidden">
          <Table>
            <TableHeader className="bg-[#232834]">
              <TableRow className="hover:bg-[#2c3440] border-b border-gray-700">
                <TableHead className="text-gray-400">Transaction</TableHead>
                <TableHead className="text-gray-400">Client</TableHead>
                <TableHead className="text-gray-400">Date</TableHead>
                <TableHead className="text-gray-400 text-right">Amount</TableHead>
                <TableHead className="text-gray-400 text-right">Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center py-16">
                    <Spinner size="lg" />
                  </TableCell>
                </TableRow>
              ) : filteredCharges?.length > 0 ? (
                filteredCharges?.slice(0, 8).map((item, index) => (
                  <TableRow key={item.transactionId || index} className="hover:bg-[#232834] border-b border-gray-700">
                    <TableCell className="text-white">{item?.type || "Transaction"}</TableCell>
                    <TableCell className="text-white">{item?.company || "Unknown"}</TableCell>
                    <TableCell className="text-white">{moment(item?.date).format("DD MMM YYYY, hh:mm A")}</TableCell>
                    <TableCell className="text-right text-white">
                      ${parseFloat(item?.amount || 0).toFixed(2)}
                    </TableCell>
                    <TableCell className="text-right text-white">
                      <span
                        className={`px-3 py-1 rounded-full text-xs ${
                          item?.status === "Completed"
                            ? "bg-green-900 text-green-300"
                            : "bg-yellow-900 text-yellow-300"
                        }`}
                      >
                        {item?.status}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className="text-center text-gray-400 py-10">
                    No recent transactions found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentTransactions;
